import React from 'react';
import loadable from '@loadable/component';
import Loader from 'components/Loader';

const BookingServices = loadable(() => import(/* webpackChunkName: "BookingServices" */ './Services'), {
  fallback: <Loader visible />,
});

export default BookingServices;
